// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../ASSETS/BACKGROUND/about-hero.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compact text hero on KUR's dark wave texture, aligned to the site grid. */
.textHero_hero__Alibb {
  position: relative;
  isolation: isolate;
  background: var(--color-ink) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  color: var(--color-text-on-dark);
  font-family: var(--font-sans);
  padding: calc(80px + clamp(3rem, 2rem + 4vw, 6rem)) var(--gutter) clamp(3rem, 2rem + 4vw, 5.5rem);
  border-bottom: 1px solid var(--color-border-on-dark);
  overflow: clip;
}
/* soft gold light that drifts slowly behind the copy */
.textHero_glow__gbBkz {
  position: absolute;
  z-index: -1;
  top: -20%;
  right: -10%;
  width: min(60rem, 90vw);
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(closest-side, rgba(255, 215, 0, 0.14), rgba(255, 215, 0, 0) 70%);
  animation: textHero_drift__P4svX 18s ease-in-out infinite alternate;
  pointer-events: none;
}
@keyframes textHero_drift__P4svX {
  to {
    transform: translate(-12%, 18%) scale(1.1);
  }
}
.textHero_inner__e77pQ {
  max-width: var(--container);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-5);
}
.textHero_title__DXF8d {
  margin: 0;
  max-width: 15em;
  font-size: var(--text-h1);
  line-height: var(--leading-tight);
  font-weight: 500;
  letter-spacing: var(--tracking-display);
  text-wrap: balance;
}
.textHero_title__DXF8d em {
  font-style: normal;
  color: var(--color-accent);
}
.textHero_lead__-oLVp {
  margin: 0;
  max-width: 40rem;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  color: var(--color-text-muted-on-dark);
}
.textHero_actions__64-Ih {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-2);
}
.textHero_extra__A11Zu {
  width: 100%;
  margin-top: var(--space-4);
}
@media (prefers-reduced-motion: reduce) {
  .textHero_glow__gbBkz {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/TEXT_HERO/textHero.module.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6FAAmG;EACnG,gCAAgC;EAChC,6BAA6B;EAC7B,iGAAiG;EACjG,oDAAoD;EACpD,cAAc;AAChB;AACA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,4FAA4F;EAC5F,mEAAmD;EACnD,oBAAoB;AACtB;AACA;EACE;IACE,0CAA0C;EAC5C;AACF;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Compact text hero on KUR's dark wave texture, aligned to the site grid. */\n.hero {\n  position: relative;\n  isolation: isolate;\n  background: var(--color-ink) url(\"../../ASSETS/BACKGROUND/about-hero.png\") center / cover no-repeat;\n  color: var(--color-text-on-dark);\n  font-family: var(--font-sans);\n  padding: calc(80px + clamp(3rem, 2rem + 4vw, 6rem)) var(--gutter) clamp(3rem, 2rem + 4vw, 5.5rem);\n  border-bottom: 1px solid var(--color-border-on-dark);\n  overflow: clip;\n}\n/* soft gold light that drifts slowly behind the copy */\n.glow {\n  position: absolute;\n  z-index: -1;\n  top: -20%;\n  right: -10%;\n  width: min(60rem, 90vw);\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: radial-gradient(closest-side, rgba(255, 215, 0, 0.14), rgba(255, 215, 0, 0) 70%);\n  animation: drift 18s ease-in-out infinite alternate;\n  pointer-events: none;\n}\n@keyframes drift {\n  to {\n    transform: translate(-12%, 18%) scale(1.1);\n  }\n}\n.inner {\n  max-width: var(--container);\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-5);\n}\n.title {\n  margin: 0;\n  max-width: 15em;\n  font-size: var(--text-h1);\n  line-height: var(--leading-tight);\n  font-weight: 500;\n  letter-spacing: var(--tracking-display);\n  text-wrap: balance;\n}\n.title em {\n  font-style: normal;\n  color: var(--color-accent);\n}\n.lead {\n  margin: 0;\n  max-width: 40rem;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted-on-dark);\n}\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin-top: var(--space-2);\n}\n.extra {\n  width: 100%;\n  margin-top: var(--space-4);\n}\n@media (prefers-reduced-motion: reduce) {\n  .glow {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `textHero_hero__Alibb`,
	"glow": `textHero_glow__gbBkz`,
	"drift": `textHero_drift__P4svX`,
	"inner": `textHero_inner__e77pQ`,
	"title": `textHero_title__DXF8d`,
	"lead": `textHero_lead__-oLVp`,
	"actions": `textHero_actions__64-Ih`,
	"extra": `textHero_extra__A11Zu`
};
export default ___CSS_LOADER_EXPORT___;
